import React from 'react';

function DurationMouseOver(props) {
  console.log('Props in Duration Mouse Over-----', props);
  return (
    <div
      className="mouseover-popups duration-mouseover font9"
      // className="mouseover-popups terminal-mouseover nowrap font9"
      ref={el => {
        props.terminalEl[props.service.id + '1'] = el;
      }}
      style={{
        // minWidth: props.label && props.label.length > 25 ? 260 : 200,
        minWidth: 270,
        maxWidth: 400,
        marginTop:
          '-' +
          (props.terminalEl[props.service.id + '1']
            ? props.terminalEl[props.service.id + '1'].clientHeight / 2
            : 0) +
          'px',
      }}
      // style={{ minWidth: 160, marginTop: 0 }}
    >
      <div style={{ lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
        {/* <span>{props.service.dropoff_stages.split('|')[0] || props.label}</span> */}
        <span>{props.label}</span>
      </div>
      <span
        style={props.label && props.label.length > 30 ? { top: 20 } : { top: 20 }}
        className="primary-triangle"
      >
        {' '}
      </span>
    </div>
  );
}

export default DurationMouseOver;



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/ServiceItem/components/DurationMouseOver.js